import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    error: null,
    zoomLinks: [],
    loading: false,
    courseContent: [],
};

const zoomLinksSlice = createSlice({
    name: 'zoomLinks',
    initialState,
    reducers: {
        setZoomLinks: (state, action) => {
            state.zoomLinks = Array.isArray(action.payload) ? action.payload?.map((item, index) => ({ ...item })) : [];
        },
        setCourseContent: (state, action) => {
            state.courseContent = action.payload;
        },
    },
    extraReducers: (builder) => {
    },
});

export const { setZoomLinks, setCourseContent } = zoomLinksSlice.actions;

export default zoomLinksSlice.reducer;